import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=2527b63a&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=2527b63a&lang=less&scoped=true&"
import style1 from "./Result.vue?vue&type=style&index=1&id=2527b63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527b63a",
  null
  
)

export default component.exports